export { default } from './ConstructorPeople';
